module.exports = __webpack_public_path__ + "static/media/how-to-swab-step-04-2x.4359b0e5.png";